export default ["🤑", "🤩", "😍", "😎", "😃", "😬", "😨"];
